import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DatePipe} from '@angular/common';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';


const apiPrefix = '/bookings/v1/';

const routes = {
    getFilteredBookings: (page: number, size: number) => apiPrefix + `bookings-by-filter?page=${page}&size=${size}`,
    getShipmentDetails: () => apiPrefix + `shipment-details-by-booking-id-and-bl`,
    getTrackingByBookingId: () => apiPrefix + `shipment-tracking`,
    getPorts: () => apiPrefix + `ports`,
    getBookingOrderTypes: () => apiPrefix + `booking-order-types`,
    getSICounts: () => apiPrefix + `si-count`,
    getPublicTrackingByTrackingId: () => apiPrefix + `public-shipment-tracking`,
    getBookingDocuments: () => apiPrefix + `booking-documents`,
};


@Injectable({
    providedIn: 'root'
})
export class BookingService {

    constructor(private http: HttpClient) {
    }

    getFilteredBookings(filterObj: any, page: number, size: number) {
        if (filterObj === {} || filterObj === null || !filterObj) {
            filterObj = {
                activeOnly: true,
                filterByIdentifier: null,
                orderTypes: null,
                loadPort: null,
                dischargePort: null,
                customerReferenceNumber: null,
                fromDate: null,
                toDate: null,
                submittedSI: false,
                draftSI: false,
                businessEntityId: '',
            };
        }
        const datePipe = new DatePipe('en-US');
        filterObj.fromDate = filterObj?.fromDate?.toString()?.length > 0 ?
            datePipe.transform(filterObj.fromDate, 'yyyy-MM-dd\'T\'HH:mm:ss') : '';
        filterObj.toDate = filterObj?.toDate?.toString()?.length > 0 ?
            datePipe.transform(filterObj.toDate, 'yyyy-MM-dd\'T\'HH:mm:ss') : '';
        const q = JSON.stringify(filterObj);

        const $bookings: Observable<any> = this.http
            .get(routes.getFilteredBookings(page, size), {
                params: {
                    q,
                }
            })
            .pipe(
                map(
                    (x) => {
                        return x;
                    }
                )
            );
        return $bookings;
    }

    getShipmentDetails(bookingId: string, blNumber: string) {
        const $shipmentDetail: Observable<any> = this.http
            .get(routes.getShipmentDetails(), {
                params: {
                    bookingId,
                    blNumber,
                },
            })
            .pipe(
                map(
                    (shipmentDetails) => {
                        return shipmentDetails as any;
                    }
                )
            );
        // of(
        // DataBuilder.buildActualData(shipmentType));
        return $shipmentDetail;
    }

    getTrackingByBookingId(trackingId: string) {
        const $tracking: Observable<any> = this.http
            .get(routes.getTrackingByBookingId(), {
                params: {
                    identifier: trackingId
                }
            }).pipe(
                map(
                    (trackingData) => {
                        return trackingData as any;
                    }
                )
            );
        return $tracking;
    }

    getAllPorts() {
        const $ports: Observable<any> = this.http
            .get(routes.getPorts())
            .pipe(
                map(
                    (x) => {
                        return x;
                    }
                )
            );
        return $ports;
    }

    getBookingOrderTypes() {
        const $orderType: Observable<any> = this.http
            .get(routes.getBookingOrderTypes())
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $orderType;
    }

    getBookingsSiCount(businessEntityId: any) {
        const $counts: Observable<any> = this.http
            .get(routes.getSICounts(), {
                params: {
                    businessEntityId: businessEntityId ? businessEntityId : ''
                }
            })
            .pipe(
                map((x: any) => {
                    return x as any;
                })
            );
        return $counts;
    }

    getPublicTrackingByTrackingId(trackingId: any) {
        const $tracking: Observable<any> = this.http
            .get(routes.getPublicTrackingByTrackingId(), {
                params: {
                    identifier: trackingId
                }
            }).pipe(
                map(
                    (trackingData) => {
                        return trackingData as any;
                    }
                )
            );
        return $tracking;
    }

    getBookingDocumentsByGid(bookingGid: any) {
        const $documents: Observable<any> = this.http
            .get(routes.getBookingDocuments(), {
                params: {
                    bookingGid
                }
            })
            .pipe(
                map((documents) => {
                    return documents as any;
                })
            );
        return $documents;
    }
}
